import { graphql, type ResultOf } from '@tucan/graphql'

export const COMPANY_SETTING_FRAGMENT = graphql(`
  fragment CompanySetting on CompanySetting @_unmask {
    id
    name
    value
    fileReadUrl
    created
    updated
  }
`)

export type CompanySettingFragment = ResultOf<typeof COMPANY_SETTING_FRAGMENT>
